export function tabview(ctx) {
    return {
        properties: {
            btn_pos: 1,
            text_font: 32,
        },
        styles: {
            main: { ...ctx.pretty, bg_color: ctx.COLOR_SCR, radius: 0, border_width: 0 },  // outer container = COLOR_SCR light = #eaeff3
            // indicator = tabview_indic (accent colour)
            indicator: { bg_color: ctx.accent },
            // items/tab-bg = tabview_btns_bg
            items: { bg_color: ctx.COLOR_BG, border_color: ctx.COLOR_BG_BORDER, border_width: 0, radius: 0, text_color: ctx.COLOR_SCR_TEXT },  // tab header bar = COLOR_BG light = #ffffff; text = #3b3e42
        },
    };
}
